// Public collection view page - displays a collection in magazine-style layout
import { useParams } from 'react-router-dom';
import { useCollectionGraphQL } from '../graphql/hooks/useCollectionsGraphQL';
import { isValidGlobalId } from '../utils/urls';
import { CollectionAndDetailView2 } from '@/components/CollectionAndDetailView2';

export function CollectionDetailPage() {
  const { collectionId } = useParams<{
    collectionId?: string;
  }>();

  // Validate global ID format
  if (!collectionId || !isValidGlobalId(collectionId)) {
    return (
      <div className="text-center text-danger py-12">
        <h2 className="text-2xl font-semibold mb-2">Invalid Collection ID</h2>
        <p>The collection ID format is invalid. Please check the URL and try again.</p>
      </div>
    );
  }

  // Fetch collection metadata and items together via GraphQL
  const {
    data: collection,
    items,
    isLoading,
    error
  } = useCollectionGraphQL(collectionId);

  if (isLoading) {
    return (
      <div className="text-center text-muted py-12">
        <p>Loading collection...</p>
      </div>
    );
  }

  if (error || !collection) {
    return (
      <div className="text-center text-danger py-12">
        <h2 className="text-2xl font-semibold mb-2">Collection Not Found</h2>
        <p>The collection you're looking for doesn't exist or has been removed.</p>
      </div>
    );
  }

  return (
    <>
      <header className="mb-8">
        <h1 className="text-3xl font-bold mb-2">{collection.name}</h1>
      </header>

      {collection.description && (
        <div className="mb-8 text-foreground">
          <p className="text-lg leading-relaxed">{collection.description}</p>
        </div>
      )}

      {items && items.length > 0 && (
        <CollectionAndDetailView2
          photos={items}
          collectionPosition="top"
          layout="magazine"
          itemTemplate={collection.showExif ? 'collection-view-exif' : 'collection-view'}
          selectionMode="none"
          hideDetail={true}
        />
      )}

      {items && items.length === 0 && (
        <div className="text-center text-muted py-12">
          <p>This collection is empty.</p>
        </div>
      )}
    </>
  );
}
